// Toymobile — sélecteur de scène et galerie de la fiche produit
(function () {
  const root = document.querySelector('[data-product]');
  if (!root) return;

  const jsonEl = document.querySelector('[data-product-json]');
  let product = null;
  try {
    product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
  } catch (err) {
    console.error('Toymobile: produit illisible', err);
  }

  const mainImage = root.querySelector('[data-main-image]');
  const thumbs = root.querySelectorAll('[data-thumb]');
  const idInput = root.querySelector('[data-variant-id]');
  const priceEl = root.querySelector('[data-price]');
  const labelEls = document.querySelectorAll('[data-variant-label]');
  const zooms = document.querySelectorAll('[data-scene-zoom]');

  // Nom de scène = partie avant « — » dans le titre de variante (ex. « Garage Drift »).
  const sceneName = (title) => title.split(' — ')[0].trim();

  // Galerie : on garde les images dont le texte alternatif commence par la scène,
  // plus les images communes (sans nom de scène). Si aucune ne correspond, tout reste visible.
  const sceneNames = product ? product.variants.map((v) => sceneName(v.title)) : [];
  const filterThumbs = (scene) => {
    const belongs = (alt) => alt.startsWith(scene);
    const isShared = (alt) => !sceneNames.some((n) => alt.startsWith(n));
    const matches = [...thumbs].filter((t) => belongs(t.dataset.alt || ''));
    thumbs.forEach((t) => {
      const alt = t.dataset.alt || '';
      t.hidden = matches.length > 0 && !belongs(alt) && !isShared(alt);
    });
  };

  const showZoom = (scene) => {
    zooms.forEach((z) => { z.hidden = z.dataset.sceneZoom !== scene; });
  };
  const addBtn = root.querySelector('[data-add]');
  const qtyInput = root.querySelector('input[name="quantity"]');

  const formatMoney = (cents) =>
    new Intl.NumberFormat('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' })
      .format(cents / 100);

  const showImage = (src) => {
    if (!mainImage || !src) return;
    mainImage.removeAttribute('srcset');
    mainImage.src = src;
    thumbs.forEach((t) => t.setAttribute('aria-current', t.dataset.thumb.split('?')[0] === src.split('?')[0] ? 'true' : 'false'));
  };

  thumbs.forEach((btn) => btn.addEventListener('click', () => showImage(btn.dataset.thumb)));

  root.querySelectorAll('input[name="tm-variant"]').forEach((radio) => {
    radio.addEventListener('change', () => {
      if (!product) return;
      const variant = product.variants.find((v) => String(v.id) === radio.value);
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      labelEls.forEach((el) => { el.textContent = variant.title; });
      filterThumbs(sceneName(variant.title));
      showZoom(sceneName(variant.title));
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
      }
      if (variant.featured_image) {
        const src = variant.featured_image.src.replace(/^https?:/, '');
        const sized = src + (src.includes('?') ? '&' : '?') + 'width=1100';
        showImage(sized);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    });
  });

  const checked = root.querySelector('input[name="tm-variant"]:checked');
  if (checked && product) {
    const initial = product.variants.find((v) => String(v.id) === checked.value);
    if (initial) filterThumbs(sceneName(initial.title));
  }

  root.querySelectorAll('[data-qty]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(btn.dataset.qty));
      qtyInput.value = next;
    });
  });
})();
